import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { QBtn, QCard, QCardSection, QExpansionItem, QForm, QIcon, QInput, QItem, QItemLabel, QItemSection, QList, QRadio, QSeparator, QSlideTransition, QToggle, QTooltip } from 'quasar';
import LoadingWrapper from '../../components/LoadingWrapper.vue';
import { capitalize, formatMoney } from '../../helpers';
import store from "../../store";
import useLabels from '../../utils/labels';
import { createAPIKey } from '../../utils/serviceProxy';
import useTariffWebService from '../../utils/tarif';
import TcUsage from '../TariffCalculatorInput/TcUsage.vue';
import { createUsageValidator } from '../TariffCalculatorInput/validation';
import TariffComparisonSelect from '../TariffComparisonSelect';
import labels from './labels';
import TcrResultObject from './TariffResult.vue';
import TelcoResultObject from './TelcoResult.vue';
var TcrResultList = /** @class */ (function (_super) {
    __extends(TcrResultList, _super);
    function TcrResultList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showOptions = false;
        _this.compareTariffID = 0;
        _this.additionCost = 0;
        _this.additionCostMonthly = 0;
        _this.additionCostHardWareMonthly = 0;
        _this.additionCostHardWare = 0;
        _this.countChoose = 0;
        _this.zipCode = '';
        _this.city = '';
        _this.street = '';
        _this.houseNumber = '';
        _this.houseNumberAddition = '';
        _this.usageHT = 0;
        _this.usageNT = 0;
        _this.tariff = '';
        _this.bestandskundenTarif = 3;
        _this.smartmeter = 3;
        _this.sonderabschlag = 3;
        _this.kaution = 3;
        _this.preisgarantie = 3;
        _this.bonus = 3;
        _this.portalRichtlinie = 3;
        _this.paket = 3;
        _this.vorkasse = 3;
        _this.fixpreis = 3;
        _this.vergleichsRichtlinie = 1;
        _this.handlingTarif = 3;
        _this.grundversorgungstarife = 3;
        _this.tarifeVonGrundversorgern = 3;
        _this.grenzenBeiATignorierenBis = 100;
        _this.tariftyp = '1,2,3';
        _this.netzbetreiber = '';
        _this.grundversorger = '';
        _this.netzgebiet = '';
        _this.kundenart = 0;
        _this.eco = false;
        _this.seitenGroesse = 20;
        _this.seitenNr = 1;
        _this.vertragslaufzeitBis = 0;
        _this.kuendigungsfrist = 0;
        _this.preisgarantieDauer = 0;
        _this.useTwoTariffs = 0;
        _this.isFilteringPanel = false;
        _this.versorgerIDs = '';
        _this.sortierung = 1;
        _this.details = 1;
        _this.inputTariftyp = '0';
        _this.asyncHelper = '';
        _this.tariffCalculatorIDs = '1,2,3,4,5,6';
        _this.telcoCalculatorIDs = '7';
        _this.comparisonLabel = '';
        _this.anzeigeBruttoNetto = 0;
        return _this;
    }
    TcrResultList.prototype.created = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, this.getProxyLabels()];
                    case 1:
                        _j.sent();
                        this.setHideComparisonSelect();
                        this.zipCode = this.inputData.zipCode;
                        this.city = capitalize(this.inputData.city);
                        this.street = (_a = this.inputData.street) !== null && _a !== void 0 ? _a : '';
                        this.houseNumber = (_b = this.inputData.houseNumber) !== null && _b !== void 0 ? _b : '';
                        this.houseNumberAddition = this.isTariff ? (_c = this.inputData.houseNumberAddition) !== null && _c !== void 0 ? _c : '' : '';
                        this.tariff = this.inputData.tariff;
                        this.usageNT = (_d = this.inputData.usageNT) !== null && _d !== void 0 ? _d : 0;
                        this.usageHT = this.inputData.usageHT;
                        this.useTwoTariffs = this.inputData.tariff.includes('Eintarif') ? 0 : 1;
                        this.eco = this.inputData.onlyEco;
                        this.inputTariftyp = (_e = this.inputData.tariftyp) !== null && _e !== void 0 ? _e : '';
                        this.compareTariff = (_f = this.selectCompareTariff()) !== null && _f !== void 0 ? _f : undefined;
                        this.comparisonLabel = this.labels.savingTariff.concat(" " + ((_g = this.compareTariff) === null || _g === void 0 ? void 0 : _g.versorgerName) + " (" + ((_h = this.compareTariff) === null || _h === void 0 ? void 0 : _h.tarifName) + ")");
                        this.handleBruttoNetto();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TcrResultList.prototype, "isTariff", {
        get: function () {
            return this.tariffCalculatorIDs.includes(this.inputData.tariffCalculatorTypeId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "isTelco", {
        get: function () {
            return this.telcoCalculatorIDs.includes(this.inputData.tariffCalculatorTypeId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "isTariffElectricHeatingAutoElectric", {
        get: function () {
            return this.isTariff && (this.inputData.medium.includes('electricity') || this.inputData.medium.includes('heating') || this.inputData.medium.includes('autostrom'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "showCustomerTypeSwitch", {
        get: function () {
            var _a, _b, _c, _d, _e;
            if (((_c = (_b = (_a = this.customLabelsProxyResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.functionsresultPage) === null || _c === void 0 ? void 0 : _c.showCustomerTypeSwitch) != null && ((_e = (_d = this.customLabelsProxyResult) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.functionsresultPage.showCustomerTypeSwitch) === true)
                return true;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "labels", {
        // Computed
        get: function () {
            var _a, _b;
            return __assign(__assign(__assign({}, labels), this.customLabels), (_b = (_a = this.customLabelsProxyResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.resultPage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "showBruttoNettoSwitch", {
        get: function () {
            var _a, _b, _c, _d, _e;
            if (((_c = (_b = (_a = this.customLabelsProxyResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.functionsresultPage) === null || _c === void 0 ? void 0 : _c.showNetGross) != null)
                return (_e = (_d = this.customLabelsProxyResult) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.functionsresultPage.showNetGross;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    TcrResultList.prototype.setHideComparisonSelect = function () {
        var _a, _b, _c, _d, _e;
        if (((_c = (_b = (_a = this.customLabelsProxyResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.functionsresultPage) === null || _c === void 0 ? void 0 : _c.hideComparisonSelect) != null)
            store.states.hideComparisonSelect = (_e = (_d = this.customLabelsProxyResult) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.functionsresultPage.hideComparisonSelect;
        else
            store.states.hideComparisonSelect = false;
    };
    Object.defineProperty(TcrResultList.prototype, "hideComparisonSelect", {
        get: function () {
            return store.states.hideComparisonSelect;
        },
        enumerable: false,
        configurable: true
    });
    TcrResultList.prototype.handleBruttoNetto = function () {
        switch (this.inputData.customerType) {
            case 0:
                this.inputData.anzeigeNettoBrutto = 1;
                break;
            case 1:
                this.inputData.anzeigeNettoBrutto = 0;
                break;
            default:
                this.inputData.anzeigeNettoBrutto = 1;
                break;
        }
        this.anzeigeBruttoNetto = this.inputData.anzeigeNettoBrutto;
    };
    TcrResultList.prototype.watchCompareTariff = function () {
        var _a, _b, _c;
        this.compareTariff = (_a = this.selectCompareTariff()) !== null && _a !== void 0 ? _a : undefined;
        this.comparisonLabel = this.labels.savingTariff.concat(" " + ((_b = this.compareTariff) === null || _b === void 0 ? void 0 : _b.versorgerName) + " (" + ((_c = this.compareTariff) === null || _c === void 0 ? void 0 : _c.tarifName) + ")");
    };
    TcrResultList.prototype.handleAnzeige = function () {
        this.inputData.anzeigeNettoBrutto = this.anzeigeBruttoNetto;
    };
    TcrResultList.prototype.selectCompareTariff = function () {
        var _a, _b;
        if (!this.syncResList)
            return undefined;
        return this.choseProduct((_b = (_a = this.syncResList) === null || _a === void 0 ? void 0 : _a.findIndex) === null || _b === void 0 ? void 0 : _b.call(_a, function (f) { return f.isVergleichsTarif; }));
    };
    TcrResultList.prototype.getProxyLabels = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apikey, getExternalLabels, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _b.sent();
                        getExternalLabels = useLabels({ apikey: apikey }).getExternalLabels;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, 5, 6]);
                        _a = this;
                        return [4 /*yield*/, getExternalLabels(this.inputData.tariffCalculatorTypeId, undefined, 'resultpage')];
                    case 3:
                        _a.customLabelsProxyResult = (_b.sent()).data;
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _b.sent();
                        throw new Error(e_1.message);
                    case 5:
                        this.syncLabelID += 1;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TcrResultList.prototype, "isLabelLoaded", {
        get: function () {
            return this.syncLabelID > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "isEnergyContext", {
        get: function () {
            return this.context === 'electricity';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "isGasContext", {
        get: function () {
            return this.context === 'gas';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "invalidValueHT", {
        get: function () {
            return createUsageValidator(1, 999999, this.labels.usageInvalidMessage)(this.usageHT);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "invalidValueNT", {
        get: function () {
            return createUsageValidator(1, 999999, this.labels.usageInvalidMessage)(this.usageNT);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcrResultList.prototype, "onlyEcoLabel", {
        get: function () {
            if (this.isGasContext)
                return this.labels.onlyGasEco;
            return this.labels.onlyElectricityEco;
        },
        enumerable: false,
        configurable: true
    });
    TcrResultList.prototype.getAPIKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apikey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        apikey = this.$q.cookies.get('adserv');
                        if (!!apikey) return [3 /*break*/, 2];
                        return [4 /*yield*/, createAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        this.$q.cookies.set('adserv', apikey, { expires: '4m' });
                        _a.label = 2;
                    case 2: return [2 /*return*/, apikey];
                }
            });
        });
    };
    TcrResultList.prototype.formatValue = function (value) {
        return formatMoney(value);
    };
    TcrResultList.prototype.formatNumber = function (number) {
        return number.toFixed(2).replace('.', ',');
    };
    TcrResultList.prototype.formatDate = function (datum) {
        var formatDate;
        var month = null;
        var day = null;
        if (datum) {
            if (datum === null || datum === void 0 ? void 0 : datum.dayOfMonth) {
                if (datum.dayOfMonth.toString().length < 2) {
                    day = "0" + datum.dayOfMonth;
                }
                else {
                    day = "" + datum.dayOfMonth;
                }
            }
            if (datum === null || datum === void 0 ? void 0 : datum.monthValue) {
                if (datum.monthValue.toString().length < 2) {
                    month = "0" + datum.monthValue;
                }
                else {
                    month = "" + datum.monthValue;
                }
            }
            var isNotValidFormat = ((datum === null || datum === void 0 ? void 0 : datum.year) + "-" + month + "-" + day).includes('undefined');
            if (datum && isNotValidFormat) {
                formatDate = datum;
            }
            else {
                formatDate = (datum === null || datum === void 0 ? void 0 : datum.year) + "-" + month + "-" + day;
            }
        }
        else
            return '';
        return formatDate;
    };
    TcrResultList.prototype.readOnly = function (item, group) {
        var readOnly = item.readonly;
        if (item.relConditions && item.relConditions.length > 0) {
            readOnly = true;
            item.relConditions.forEach(function (con) {
                if (group.entries.find(function (s) { return s.refRootId.toString() === con.split("#")[1] && s.isSelected; })) {
                    readOnly = false;
                }
            });
        }
        else {
            readOnly = item.readonly;
        }
        return readOnly;
    };
    TcrResultList.prototype.choseTelcoProduct = function (index) {
        var _this = this;
        if (!index && index < 0)
            return undefined;
        var _a = this.syncResTelcoList[index], rootId = _a.rootId, productName = _a.productName, productTypeId = _a.productTypeId, productTypeName = _a.productTypeName, companyId = _a.companyId, companyName = _a.companyName, providerId = _a.providerId, providerName = _a.providerName, productCode = _a.productCode, productCodeExtern = _a.productCodeExtern, validFrom = _a.validFrom, validTo = _a.validTo, customerGroupPrivate = _a.customerGroupPrivate, customerGroupCommercial = _a.customerGroupCommercial, customerGroupYoungPeople = _a.customerGroupYoungPeople, gridConnectionType = _a.gridConnectionType, connectionTypes = _a.connectionTypes, contractPeriodType = _a.contractPeriodType, contractPeriodMonths = _a.contractPeriodMonths, contractPeriodDate = _a.contractPeriodDate, noticePeriodMonths = _a.noticePeriodMonths, contractExtensionType = _a.contractExtensionType, contractExtensionMonths = _a.contractExtensionMonths, contractExtensionDate = _a.contractExtensionDate, productDescription = _a.productDescription, productDescriptionPlain = _a.productDescriptionPlain, landlineDataVolumeFlat = _a.landlineDataVolumeFlat, landlineDataVolumeLimit = _a.landlineDataVolumeLimit, landlineInternetDownloadSpeed = _a.landlineInternetDownloadSpeed, landlineInternetDownloadSpeedMinimal = _a.landlineInternetDownloadSpeedMinimal, landlineInternetDownloadSpeedNormal = _a.landlineInternetDownloadSpeedNormal, landlineInternetUploadSpeed = _a.landlineInternetUploadSpeed, landlineInternetUploadSpeedMinimal = _a.landlineInternetUploadSpeedMinimal, landlineInternetUploadSpeedNormal = _a.landlineInternetUploadSpeedNormal, landlineTelephone = _a.landlineTelephone, landlineTelephoneNumbers = _a.landlineTelephoneNumbers, landlineTelephoneFlatLandline = _a.landlineTelephoneFlatLandline, landlineTelephoneCostMinutes = _a.landlineTelephoneCostMinutes, setupCost = _a.setupCost, shippingCosts = _a.shippingCosts, monthlyPrices = _a.monthlyPrices, productDocuments = _a.productDocuments, optionGroups = _a.optionGroups, hardwareGroups = _a.hardwareGroups, lastUpdateDate = _a.lastUpdateDate, lastUpdateUserId = _a.lastUpdateUserId, version = _a.version;
        var maxShippingCost = 0;
        if (shippingCosts && shippingCosts > maxShippingCost)
            maxShippingCost = shippingCosts;
        var monthlyPricesTemp = [];
        var productDocumentsTemp = [];
        var optionGroupTemp = [];
        var hardwareGroupTemp = [];
        this.additionCostMonthly = 0;
        this.additionCost = 0;
        this.additionCostHardWareMonthly = 0;
        this.additionCostHardWare = 0;
        optionGroups === null || optionGroups === void 0 ? void 0 : optionGroups.forEach(function (group) {
            var _a;
            var optionsTemp = [];
            (_a = group.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (o) {
                if (o.isSelected && (o.preselectedAndReadonly === true || !_this.readOnly(o, group))) {
                    var temp_1 = __assign({}, o);
                    if (temp_1.shippingCosts > maxShippingCost)
                        maxShippingCost = temp_1.shippingCosts;
                    temp_1.monthlyPrice = _this.monthlyPrice(temp_1.monthlyPrices);
                    if (temp_1.monthlyPrice)
                        _this.additionCostMonthly += temp_1.monthlyPrice;
                    _this.additionCost += temp_1.priceOneTime;
                    //  GETTR-1536 TR4 Internet Optionen | Anzahl auswählen
                    if (temp_1 && temp_1.chooseAmount && temp_1.chooseAmount > 1) {
                        temp_1.optionsSum = { chooseAmount: temp_1.chooseAmount, priceOneTime: 0, monthlyPrice: 0, monthlyPrices: [] };
                        temp_1.optionsSum.priceOneTime = temp_1.priceOneTime * temp_1.chooseAmount;
                        temp_1.optionsSum.monthlyPrice = (temp_1.monthlyPrice) ? temp_1.monthlyPrice * temp_1.chooseAmount : undefined;
                        temp_1.monthlyPrices.forEach(function (p) {
                            var _a;
                            var tempOpt = __assign({}, p);
                            (_a = temp_1.optionsSum) === null || _a === void 0 ? void 0 : _a.monthlyPrices.push(tempOpt);
                        });
                        temp_1.optionsSum.monthlyPrices.forEach(function (p) {
                            if (temp_1.chooseAmount)
                                // eslint-disable-next-line no-param-reassign
                                p.pricePerMonth = (p.pricePerMonth) ? p.pricePerMonth * temp_1.chooseAmount : 0;
                        });
                    }
                    temp_1.relConditions = [];
                    temp_1.relAttributes = [];
                    optionsTemp.push(temp_1);
                }
            });
            var tempGroup = __assign({}, group);
            tempGroup.entries = optionsTemp;
            optionGroupTemp.push(tempGroup);
        });
        hardwareGroups === null || hardwareGroups === void 0 ? void 0 : hardwareGroups.forEach(function (group) {
            var _a;
            var hardwareTemp = [];
            (_a = group.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (h) {
                if (h.isSelected && (h.preselectedAndReadonly === true || !_this.readOnly(h, group))) {
                    var temp = __assign({}, h);
                    temp.relConditions = [];
                    temp.relAttributes = [];
                    temp.monthlyPrice = _this.monthlyPrice(temp.monthlyPrices);
                    if (temp.shippingCosts > maxShippingCost)
                        maxShippingCost = temp.shippingCosts;
                    if (temp.monthlyPrice)
                        _this.additionCostHardWareMonthly += temp.monthlyPrice;
                    _this.additionCostHardWare += temp.priceOneTime;
                    hardwareTemp.push(temp);
                }
            });
            var tempGroup = __assign({}, group);
            tempGroup.entries = hardwareTemp;
            hardwareGroupTemp.push(tempGroup);
        });
        monthlyPrices === null || monthlyPrices === void 0 ? void 0 : monthlyPrices.forEach(function (d) {
            var temp = __assign({}, d);
            monthlyPricesTemp.push(temp);
        });
        productDocuments === null || productDocuments === void 0 ? void 0 : productDocuments.forEach(function (d) {
            var temp2 = __assign({}, d);
            productDocumentsTemp.push(temp2);
        });
        var tempMonthlyPrice = this.monthlyPrice(monthlyPricesTemp);
        if (!tempMonthlyPrice)
            tempMonthlyPrice = 0;
        var tempBasicPrice = tempMonthlyPrice + this.additionCostMonthly + this.additionCostHardWareMonthly;
        var tempSetupCost = this.additionCost + this.additionCostHardWare;
        if (setupCost)
            tempSetupCost += setupCost;
        return {
            rootId: rootId,
            productName: productName,
            productTypeId: productTypeId,
            productTypeName: productTypeName,
            companyId: companyId,
            companyName: companyName,
            providerId: providerId,
            providerName: providerName,
            productCode: productCode,
            productCodeExtern: productCodeExtern,
            validFrom: validFrom,
            validTo: validTo,
            customerGroupPrivate: customerGroupPrivate,
            customerGroupCommercial: customerGroupCommercial,
            customerGroupYoungPeople: customerGroupYoungPeople,
            gridConnectionType: gridConnectionType,
            connectionTypes: connectionTypes,
            contractPeriodType: contractPeriodType,
            contractPeriodMonths: contractPeriodMonths,
            contractPeriodDate: contractPeriodDate,
            noticePeriodMonths: noticePeriodMonths,
            contractExtensionType: contractExtensionType,
            contractExtensionMonths: contractExtensionMonths,
            contractExtensionDate: contractExtensionDate,
            productDescription: productDescription,
            productDescriptionPlain: productDescriptionPlain,
            landlineDataVolumeFlat: landlineDataVolumeFlat,
            landlineDataVolumeLimit: landlineDataVolumeLimit,
            landlineInternetDownloadSpeed: landlineInternetDownloadSpeed,
            landlineInternetDownloadSpeedMinimal: landlineInternetDownloadSpeedMinimal,
            landlineInternetDownloadSpeedNormal: landlineInternetDownloadSpeedNormal,
            landlineInternetUploadSpeed: landlineInternetUploadSpeed,
            landlineInternetUploadSpeedMinimal: landlineInternetUploadSpeedMinimal,
            landlineInternetUploadSpeedNormal: landlineInternetUploadSpeedNormal,
            landlineTelephone: landlineTelephone,
            landlineTelephoneNumbers: landlineTelephoneNumbers,
            landlineTelephoneFlatLandline: landlineTelephoneFlatLandline,
            landlineTelephoneCostMinutes: landlineTelephoneCostMinutes,
            installCost: setupCost,
            setupCost: tempSetupCost,
            basicPrice: tempBasicPrice,
            shippingCosts: shippingCosts,
            shippingCost: maxShippingCost,
            monthlyPrices: monthlyPricesTemp,
            productDocuments: productDocumentsTemp,
            optionGroups: optionGroupTemp,
            hardwareGroups: hardwareGroupTemp,
            lastUpdateDate: lastUpdateDate,
            lastUpdateUserId: lastUpdateUserId,
            version: version,
            grundpreisBrutto: 0,
            gesamtpreisBrutto: 0,
            arbeitspreisBrutto: 0,
            arbeitspreisHTCtKWhBrutto: 0,
            arbeitspreisNetto: 0,
            arbeitspreisNTCtKWhBrutto: 0,
            arbeitspreisNTCtKWhNetto: 0,
            ersparnisBrutto: 0,
            ersparnisNetto: 0,
            arbeitspreisHTCtKWhNetto: 0,
            gesamtpreisNetto: 0,
            gesamtpreisOhneBoniBrutto: 0,
            gesamtpreisOhneBoniNetto: 0,
            grundpreisNetto: 0,
            gueltigVon: '',
            isGrundversorgungsTarif: false,
            isOekostromTarif: false,
            isOekogasTarif: false,
            isPaketTarif: false,
            isVergleichsTarif: false,
            isVorkasseTarif: false,
            kuendigungsfrist: '0',
            kuendigungsfristID: 0,
            markenID: 0,
            tarifCode: '',
            tarifID: 0,
            tarifInfo: '',
            tarifName: productName,
            tarifRootID: rootId,
            variantenID: '',
            versorgerID: providerId,
            versorgerName: providerName || '',
            vertragslaufzeit: '',
            vertragslaufzeitID: 0,
            vertragsverlaengerung: '',
            vertragsverlaengerungID: 0,
            informationen: [],
            dynamischeAngaben: [],
            arbeitspreisCtKWhBrutto: 0,
            arbeitspreisCtKWhNetto: 0,
            preisStaffeln: []
        };
    };
    TcrResultList.prototype.monthlyPrice = function (item) {
        if ((item === null || item === void 0 ? void 0 : item.length) > 0) {
            var pricePerMonth = item[0].pricePerMonth;
            return pricePerMonth;
        }
        return undefined;
    };
    TcrResultList.prototype.loadTariffCard = function (tarifRootID, variantenID) {
        return __awaiter(this, void 0, void 0, function () {
            var apikey, getTariffCart, trCard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        getTariffCart = useTariffWebService({ apikey: apikey }, this.context).getTariffCart;
                        return [4 /*yield*/, getTariffCart(this.inputData, tarifRootID, variantenID)];
                    case 2:
                        trCard = _a.sent();
                        if (trCard === null || trCard === void 0 ? void 0 : trCard.tarifkarte[0].zeitZone)
                            return [2 /*return*/, trCard === null || trCard === void 0 ? void 0 : trCard.tarifkarte[0].zeitZone[0].preisStaffeln];
                        return [2 /*return*/, trCard === null || trCard === void 0 ? void 0 : trCard.tarifkarte[0].preisStaffel];
                }
            });
        });
    };
    TcrResultList.prototype.choseProduct = function (index) {
        var _this = this;
        if (index < 0)
            return undefined;
        var card = this.loadTariffCard(this.syncResList[index].tarifRootID, this.syncResList[index].variantenID);
        var _a = this.syncResList[index], grundpreisBrutto = _a.grundpreisBrutto, gesamtpreisBrutto = _a.gesamtpreisBrutto, arbeitspreisHTCtKWhBrutto = _a.arbeitspreisHTCtKWhBrutto, arbeitspreisBrutto = _a.arbeitspreisBrutto, arbeitspreisHTCtKWhNetto = _a.arbeitspreisHTCtKWhNetto, arbeitspreisNetto = _a.arbeitspreisNetto, arbeitspreisNTCtKWhBrutto = _a.arbeitspreisNTCtKWhBrutto, arbeitspreisNTCtKWhNetto = _a.arbeitspreisNTCtKWhNetto, ersparnisBrutto = _a.ersparnisBrutto, ersparnisNetto = _a.ersparnisNetto, gesamtpreisNetto = _a.gesamtpreisNetto, gesamtpreisOhneBoniBrutto = _a.gesamtpreisOhneBoniBrutto, gesamtpreisOhneBoniNetto = _a.gesamtpreisOhneBoniNetto, grundpreisNetto = _a.grundpreisNetto, isGrundversorgungsTarif = _a.isGrundversorgungsTarif, isOekostromTarif = _a.isOekostromTarif, isOekogasTarif = _a.isOekogasTarif, isPaketTarif = _a.isPaketTarif, isVergleichsTarif = _a.isVergleichsTarif, isVorkasseTarif = _a.isVorkasseTarif, kuendigungsfrist = _a.kuendigungsfrist, kuendigungsfristID = _a.kuendigungsfristID, markenID = _a.markenID, tarifCode = _a.tarifCode, tarifID = _a.tarifID, tarifInfo = _a.tarifInfo, tarifName = _a.tarifName, tarifRootID = _a.tarifRootID, variantenID = _a.variantenID, versorgerID = _a.versorgerID, versorgerName = _a.versorgerName, vertragslaufzeit = _a.vertragslaufzeit, vertragslaufzeitID = _a.vertragslaufzeitID, vertragsverlaengerung = _a.vertragsverlaengerung, vertragsverlaengerungID = _a.vertragsverlaengerungID, gueltigVon = _a.gueltigVon, informationen = _a.informationen, dynamischeAngaben = _a.dynamischeAngaben, arbeitspreisCtKWhBrutto = _a.arbeitspreisCtKWhBrutto, arbeitspreisCtKWhNetto = _a.arbeitspreisCtKWhNetto, boni = _a.boni, aufschlaege = _a.aufschlaege;
        var informationenTemp = [];
        var dynamischeAngabenTemp = [];
        var boniTemp = [];
        var aufschlaegeTemp = [];
        var preisstaffelnTemp = [];
        if (card) {
            card.then(function (a) { return a === null || a === void 0 ? void 0 : a.forEach(function (t) {
                var temp = __assign({}, t);
                preisstaffelnTemp.push(temp);
            }); });
        }
        dynamischeAngaben === null || dynamischeAngaben === void 0 ? void 0 : dynamischeAngaben.forEach(function (d) {
            var temp = __assign({}, d);
            dynamischeAngabenTemp.push(temp);
        });
        informationen === null || informationen === void 0 ? void 0 : informationen.forEach(function (i) {
            var temp = __assign(__assign({}, i), { preisgarantieBis: _this.formatDate(i.preisgarantieBis), gueltigVon: _this.formatDate(i.gueltigVon), gueltigBis: _this.formatDate(i.gueltigBis) });
            informationenTemp.push(temp);
        });
        aufschlaege === null || aufschlaege === void 0 ? void 0 : aufschlaege.forEach(function (auf) {
            var temp = __assign({}, auf);
            aufschlaegeTemp.push(temp);
        });
        boni === null || boni === void 0 ? void 0 : boni.forEach(function (b) {
            var temp = __assign({}, b);
            boniTemp.push(temp);
        });
        return {
            grundpreisBrutto: grundpreisBrutto,
            gesamtpreisBrutto: gesamtpreisBrutto,
            arbeitspreisBrutto: arbeitspreisBrutto,
            arbeitspreisHTCtKWhBrutto: arbeitspreisHTCtKWhBrutto,
            arbeitspreisNetto: arbeitspreisNetto,
            arbeitspreisNTCtKWhBrutto: arbeitspreisNTCtKWhBrutto,
            arbeitspreisNTCtKWhNetto: arbeitspreisNTCtKWhNetto,
            ersparnisBrutto: ersparnisBrutto,
            ersparnisNetto: ersparnisNetto,
            arbeitspreisHTCtKWhNetto: arbeitspreisHTCtKWhNetto,
            gesamtpreisNetto: gesamtpreisNetto,
            gesamtpreisOhneBoniBrutto: gesamtpreisOhneBoniBrutto,
            gesamtpreisOhneBoniNetto: gesamtpreisOhneBoniNetto,
            grundpreisNetto: grundpreisNetto,
            gueltigVon: this.formatDate(gueltigVon),
            isGrundversorgungsTarif: isGrundversorgungsTarif,
            isOekostromTarif: isOekostromTarif,
            isOekogasTarif: isOekogasTarif,
            isPaketTarif: isPaketTarif,
            isVergleichsTarif: isVergleichsTarif,
            isVorkasseTarif: isVorkasseTarif,
            kuendigungsfrist: kuendigungsfrist,
            kuendigungsfristID: kuendigungsfristID,
            markenID: markenID,
            tarifCode: tarifCode !== null && tarifCode !== void 0 ? tarifCode : '',
            tarifID: tarifID,
            tarifInfo: tarifInfo !== null && tarifInfo !== void 0 ? tarifInfo : '',
            tarifName: tarifName,
            tarifRootID: tarifRootID,
            variantenID: variantenID !== null && variantenID !== void 0 ? variantenID : '',
            versorgerID: versorgerID,
            versorgerName: versorgerName,
            vertragslaufzeit: vertragslaufzeit,
            vertragslaufzeitID: vertragslaufzeitID,
            vertragsverlaengerung: vertragsverlaengerung,
            vertragsverlaengerungID: vertragsverlaengerungID,
            informationen: informationenTemp,
            dynamischeAngaben: dynamischeAngabenTemp,
            arbeitspreisCtKWhBrutto: arbeitspreisCtKWhBrutto,
            arbeitspreisCtKWhNetto: arbeitspreisCtKWhNetto,
            boni: boniTemp,
            aufschlaege: aufschlaegeTemp,
            preisStaffeln: preisstaffelnTemp,
            rootId: 0,
            productName: '',
            productTypeId: 0,
            productTypeName: '',
            companyId: 0,
            companyName: '',
            providerId: 0,
            providerName: '',
            productCode: '0',
            productCodeExtern: '0',
            validFrom: undefined,
            validTo: undefined,
            customerGroupPrivate: false,
            customerGroupCommercial: false,
            customerGroupYoungPeople: false,
            gridConnectionType: 0,
            connectionTypes: [],
            contractPeriodType: 0,
            contractPeriodMonths: 0,
            contractPeriodDate: undefined,
            noticePeriodMonths: 0,
            contractExtensionType: 0,
            contractExtensionMonths: 0,
            contractExtensionDate: undefined,
            productDescription: '',
            landlineDataVolumeFlat: false,
            landlineDataVolumeLimit: 0,
            landlineInternetDownloadSpeed: 0,
            landlineInternetDownloadSpeedMinimal: 0,
            landlineInternetDownloadSpeedNormal: 0,
            landlineInternetUploadSpeed: 0,
            landlineInternetUploadSpeedMinimal: 0,
            landlineInternetUploadSpeedNormal: 0,
            landlineTelephone: false,
            landlineTelephoneNumbers: 0,
            landlineTelephoneFlatLandline: false,
            landlineTelephoneCostMinutes: 0,
            installCost: 0,
            setupCost: 0,
            basicPrice: 0,
            shippingCosts: 0,
            shippingCost: 0,
            lastUpdateDate: undefined,
            lastUpdateUserId: 0,
            version: 0
        };
    };
    TcrResultList.prototype.changeResult = function (value) {
        this.inputData.customerType = value;
        return this.inputData;
    };
    TcrResultList.prototype.selectProduct = function (index) {
        return this.choseProduct(index);
    };
    TcrResultList.prototype.changeCompareTariff = function () { };
    TcrResultList.prototype.selectTelcoProduct = function (index) {
        return this.choseTelcoProduct(index);
    };
    TcrResultList.prototype.goTo = function () { };
    __decorate([
        Prop({ default: function () { return ({}); } })
    ], TcrResultList.prototype, "customLabels", void 0);
    __decorate([
        Prop({ required: true })
    ], TcrResultList.prototype, "inputData", void 0);
    __decorate([
        Prop()
    ], TcrResultList.prototype, "context", void 0);
    __decorate([
        Prop()
    ], TcrResultList.prototype, "usageOptions", void 0);
    __decorate([
        Prop({ required: false })
    ], TcrResultList.prototype, "productOverview", void 0);
    __decorate([
        Prop({ default: false })
    ], TcrResultList.prototype, "isLoading", void 0);
    __decorate([
        PropSync('resultList', { default: function () { return []; } })
    ], TcrResultList.prototype, "syncResList", void 0);
    __decorate([
        PropSync('resultTelcoList', { default: function () { return []; } })
    ], TcrResultList.prototype, "syncResTelcoList", void 0);
    __decorate([
        PropSync('labelID', { type: Number })
    ], TcrResultList.prototype, "syncLabelID", void 0);
    __decorate([
        PropSync('customerType', { default: 0 })
    ], TcrResultList.prototype, "syncCustomerType", void 0);
    __decorate([
        Watch('syncResList')
    ], TcrResultList.prototype, "watchCompareTariff", null);
    __decorate([
        Watch('anzeigeBruttoNetto')
    ], TcrResultList.prototype, "handleAnzeige", null);
    __decorate([
        Emit()
    ], TcrResultList.prototype, "changeResult", null);
    __decorate([
        Emit()
    ], TcrResultList.prototype, "selectProduct", null);
    __decorate([
        Emit()
    ], TcrResultList.prototype, "changeCompareTariff", null);
    __decorate([
        Emit()
    ], TcrResultList.prototype, "selectTelcoProduct", null);
    __decorate([
        Emit()
    ], TcrResultList.prototype, "goTo", null);
    TcrResultList = __decorate([
        Component({
            components: {
                QBtn: QBtn,
                QCard: QCard,
                QIcon: QIcon,
                QItem: QItem,
                QItemLabel: QItemLabel,
                QSeparator: QSeparator,
                QTooltip: QTooltip,
                QList: QList,
                QItemSection: QItemSection,
                QExpansionItem: QExpansionItem,
                QForm: QForm,
                QInput: QInput,
                QCardSection: QCardSection,
                QToggle: QToggle,
                QSlideTransition: QSlideTransition,
                TcUsage: TcUsage,
                QRadio: QRadio,
                TcrResultObject: TcrResultObject,
                TelcoResultObject: TelcoResultObject,
                TariffComparisonSelect: TariffComparisonSelect,
                LoadingWrapper: LoadingWrapper
            }
        })
    ], TcrResultList);
    return TcrResultList;
}(Vue));
export default TcrResultList;
